import { Component } from '@angular/core';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'app-confirm-leave-dialog',
	templateUrl: './confirm-leave-dialog.component.html',
	styleUrls: ['./confirm-leave-dialog.component.scss'],
	imports: [ConfirmDialogComponent],
})
export class ConfirmLeaveDialogComponent {}
